import React from "react";
import PropTypes from "prop-types";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import Expander from "../../../../components/Expander";
import { showInfo, getHeatmap, getGTExTPM } from "./helpers";

const GeneGTEx = ({ data }) => {
  if (data && Object.keys(data || {}).length > 0) {
    const { version, items } = data;
    const filteredItems = items.filter(
      (item) =>
        item.exons ||
        (item.gene_expressions &&
          Object.entries(item.gene_expressions).length !== 0)
    );
    const title = (
      <React.Fragment>
        Genotype-Tissue Expression -{" "}
        <a href={getVarsoUrl("https://gtexportal.org/home")} target="_blank">
          GTEx
        </a>
      </React.Fragment>
    );
    return (
      <div className="varsome-result-fixed" data-testid="gene-gtex-component">
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            title={title}
            version={version}
            content={
              <div className="varsome-inner-container">
                <Expander showMore="3" center={true}>
                  {filteredItems.map((item, i) => {
                    const GTExUrl = `https://gtexportal.org/home/gene/${item.gene}`;
                    const geneName = item.gene;
                    const geneInfo = showInfo(item);
                    if (
                      item.exons ||
                      (item.gene_expressions &&
                        Object.entries(item.gene_expressions).length !== 0)
                    ) {
                      let heatmap;
                      let expressions;
                      if (item.exons) {
                        heatmap = getHeatmap(
                          item.exons,
                          i,
                          item.gencode_id,
                          geneName,
                          GTExUrl
                        );
                      }
                      if (
                        item.gene_expressions &&
                        Object.entries(item.gene_expressions).length !== 0
                      ) {
                        expressions = getGTExTPM(
                          item.gene_expressions,
                          i,
                          item.gencode_id,
                          geneName,
                          GTExUrl
                        );
                      }
                      return (
                        <div key={i}>
                          {geneInfo}
                          {heatmap}
                          {expressions}
                        </div>
                      );
                    }
                    return null;
                  })}
                </Expander>
              </div>
            }
          />
        </div>
      </div>
    );
  }
  return null;
};

GeneGTEx.propTypes = {
  data: PropTypes.shape({
    version: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        exons: PropTypes.arrayOf(PropTypes.shape({})),
        gencode_id: PropTypes.string,
        gene: PropTypes.string,
        gene_expressions: PropTypes.shape({}),
        gene_model_positions: PropTypes.shape({
          strand: PropTypes.string,
          start: PropTypes.number,
          chromosome: PropTypes.string,
          end: PropTypes.number,
        }),
        gene_positions: PropTypes.shape({
          strand: PropTypes.string,
          start: PropTypes.number,
          chromosome: PropTypes.string,
          end: PropTypes.number,
        }),
      })
    ),
  }),
};

GeneGTEx.defaultProps = {
  data: null,
};

export default withErrorGuard(GeneGTEx, "GeneGTEx", "GTEx");
